<template>

    <div class="main-body position-relative">
    
      <div class="nav-title ">
          <div class="flex flex-center-cz margin-left-xl font-xl font-bold flex-space-between full-width">
              <span class="pointer"  style="width: 100px;">我的收藏</span>
              <SearchInput :val="filter"  :placeholder="'请输入文档名或内容查询'" style="width: 300px;" @search="search"></SearchInput>
              <div class="border-box" style="width: 100px;"></div>
          </div>
      </div>
      <div class="file-pnl" style="margin-top:45px">
            <div v-for="item in fileData" style="width: 25%;" class="flex flex-center-sp">
              <div class="file-box boder-box">
                <div class="pointer dir-box" @click="gridItemClick(item.docData.id)"  >
                  <img v-if="item.docData.cover != null && item.docData.cover != ''" class="file-img" :src="item.docData.cover"/>
                  <div v-if="item.docData.cover == null || item.docData.cover == ''" class="file-img padding-s font-s border-box">{{item.docData.summary}}</div>
                </div>
                <div class="file-desc">
                  <div class="file-left">
                    <div class="file-name text-more row1 full-width">{{item.docData.name}}</div>
                    <div class="flex flex-row file-remark">
                      <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{item.docData.likeCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{item.docData.viewCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{item.docData.commentCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{item.docData.collectCount}}</div></div>
                    </div>
                  </div>
                  <div class="file-right">
                    <div class="file-share pointer" @click="share(item.docData)"><img class="share-img" src="@/assets/images/share.png"/></div>
                  </div>
                </div> 
              </div> 
              
            </div>
      </div>   
      
      <div v-if="fileData != null && fileData.length == 0" style="margin-top: 50px;width: 95%;" class="flex flex-col flex-center-cz">
          <img style="width: 250px;height: 250px;" src="@/assets/images/empty-data.png"/>
          <div class="font-l">空空如也</div>
      </div>

      <Share :data="shareData" :show="showShare" @close="showShare = false"></Share>


    </div>     
    
    </template>
    
    <script>
      /*
            名称：我的收藏
            功能：
            作者：唐赢   
            时间：2022-11-30
      */
    
      import {collectList} from '@/api/api.js';
      import Mixin from '@/mixin/mixin';
      import MixinDoc from '@/mixin/mixinDoc';
      import Share from '@/modules/share/Share.vue'
      import SearchInput from '@/components/searchInput/SearchInput.vue'


      export default {
        name: 'Main',
        mixins:[Mixin,MixinDoc],
        data () {
          return {
            filter:"",
            fileData: null,
            showShare: false,
            shareData:{},
    
          }
        },
        components: {
            Share,SearchInput
        },
        created() {
          // this.filter = "";
          // this.list();

        },
        mounted() {
          if (sessionStorage.getItem("collect_filter") && sessionStorage.getItem("collect_filter")  != "") {
            this.filter = sessionStorage.getItem("collect_filter")
          } else {
            this.filter = ""
          }
          this.list();

        },        
        methods: {
            search(value) {
                this.filter = value;
                sessionStorage.setItem("collect_filter", value)
                this.list();
            },

            list() {
              this.$showLoading();
              collectList(this.filter).then((res) => {
                console.log(res);
                this.$closeLoading();
                this.fileData = res.data.result;
              })
            },
            gridItemClick(id) {
                this.$router.push({
                  path: '/doc',
                  query: {
                    id: id
                  }
              })
            },  
            stopPropa(event) {
                event || (event = window.event);
                event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
                document.addEventListener("click", this.closeClick, false);// 监听关闭事件
            },
    
            closeClick(e) {
                console.log("销毁监听事件。");
                document.removeEventListener("click", this.closeClick, false);
                this.showOpMenu = false;
            },

          
        }
      }
    </script>
    
      <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
    
        .file-right{
            width: 35px;
        }

        .dir-box {
            overflow: hidden;
            height: 170px;
        }
  
    
    </style>
      


// WEBPACK FOOTER //
// src/views/Collect.vue